<template>
  <a-card>
    <div v-if="current != -1" class="step-container">
      <a-steps :current="null" size="small" :style="{ width: `${Object.keys(steps).length * 240}px` }">
        <a-step v-for="(dateSteps, date) in steps" :key="date" :ref="el => setStepRef(el, date)" :status="dateSteps.status" :title="date">
          <template v-if="dateSteps.status === 'process'" #icon>
            <span v-if="dateSteps.status === 'process' && dateSteps.details.length <= 5 && dateSteps.details.length > 0">
              <img src="@/assets/screenshot-20241203-200513.png" alt="Custom Icon" style="width: 70px; height: 50px" />
            </span>
            <span v-else-if="dateSteps.status === 'process' && dateSteps.details.length <= 15 && dateSteps.details.length > 5">
              <img src="@/assets/less15.png" alt="Custom Icon" style="width: 70px; height: 55px" />
            </span>
            <span v-else-if="dateSteps.status === 'process' && dateSteps.details.length > 15">
              <img src="@/assets/over15.png" alt="Custom Icon" style="width: 70px; height: 60px" />
            </span>
          </template>
          <a-icon slot="icon" type="smile-o" />
          <span v-for="(step, index) in dateSteps.details" slot="description" :key="step.id" @click="openDetail(dateSteps.details, date)">
            <p v-if="index < 4">{{ '【BR-' + step.id + '】' + step.title }}</p>
            <p v-if="index == 4">{{ '...点击查看更多' }}</p>
            <p v-if="index > 4" />
          </span>
        </a-step>
      </a-steps>
    </div>
    <span v-if="current == -1">
      <img src="@/assets/sleep.jpg" style="width: 140px; height: 80px" alt="" />
      {{ '所选筛选范围暂时没有查询到有任何业务需求进展痕迹，小狐休息一下～' }}
    </span>
    <BusinessRequirementListModal ref="businessRequirementListModalRef" />
  </a-card>
</template>
<script>
import BusinessRequirementListModal from '@/pages/business/requirement/components/BusinessRequirementListModal';
import { requirementTarget } from '@/utils/dictionary';
import { getBrProgress } from '@/api/business/requirement';
const echarts = require('echarts/lib/echarts');
export default {
  components: { BusinessRequirementListModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      requirementTarget,
      showModal: 'bar',
      current: '',
      loading: true,
      stepRefs: {},
      steps: {}
    };
  },
  watch: {
    filterForm() {
      this.getData();
    },
    steps: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.scrollToProcessStep();
        });
      }
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    changeType() {},
    openDetail(item, date) {
      const ids = [];
      item.forEach(i => {
        ids.push(i.id);
      });
      this.$refs.businessRequirementListModalRef.open(date, { ids: ids });
    },
    setStepRef(el, date) {
      this.stepRefs[date] = el;
    },
    scrollToProcessStep() {
      for (const date in this.steps) {
        const step = this.steps[date];
        if (step.status === 'process') {
          const stepEl = this.stepRefs[date]?.$el;
          if (stepEl) {
            stepEl.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
            break;
          }
        }
      }
    },
    getData() {
      getBrProgress({ ...this.filterForm }).then(res => {
        this.steps = res.data.items;
        this.current = res.data.date;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
/deep/.ant-card-small > .ant-card-body {
  padding: 0;
}
.step-container {
  width: 100%;
  overflow: scroll;
}
</style>
